import { ManagerOfCompany, Pagination, UserProcess } from '@interfaces';

export const searchProcessesDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'desc',
  count: 0,
};

export type ManagerState = Readonly<{
  loadingManagedCompanies: boolean;
  managedCompanies: ManagerOfCompany[] | null;

  loadingProcesses: boolean;
  processes: Partial<UserProcess>[];
  processesPagination: Pagination;

  errorMessage: any;
}>;

export const initialState: ManagerState = {
  loadingManagedCompanies: false,
  managedCompanies: null,

  loadingProcesses: false,
  processes: [],
  processesPagination: { ...searchProcessesDefaultPagination } as Pagination,

  errorMessage: null,
};
